import { FC } from 'react';
import { Box, Typography } from '@mui/material';

import styles from './ChatHistory.module.scss';
import { ChatMessage as ChatMessageType } from '../../../../../../../types/aiChat.types';
import ChatMessage from '../ChatMessage/ChatMessage';
import TypingIndicator from '../TypingIndicator/TypingIndicator';

interface ChatHistoryProps {
  messages: ChatMessageType[];
  isLoading?: boolean;
  error?: any;
  isSending?: boolean;
  isTripPlannerMode?: boolean;
}

const ChatHistory: FC<ChatHistoryProps> = ({
  messages,
  isLoading = false,
  error,
  isSending = false,
  isTripPlannerMode = false,
}) => {
  if (isLoading && messages.length === 0) {
    return (
      <Box className={styles.chatHistory}>
        <Box className={styles.emptyState}>
          <Typography
            variant="h10"
            sx={{ color: '#5E6A81' }}
          >
            Loading messages...
          </Typography>
        </Box>
      </Box>
    );
  }

  if (error && messages.length === 0) {
    return (
      <Box className={styles.chatHistory}>
        <Box className={styles.emptyState}>
          <Typography
            variant="h10"
            sx={{ color: '#C8102E' }}
          >
            Failed to load messages
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={styles.chatHistory}>
      <Box className={styles.messagesList}>
        {messages.map(message => (
          <ChatMessage
            key={message.id}
            message={message}
            isTripPlannerMode={isTripPlannerMode}
          />
        ))}
        {isSending && <TypingIndicator />}
      </Box>
    </Box>
  );
};

export default ChatHistory;
